import { Component } from 'react';
import { connect } from 'react-redux';
import locale from './languages/languages'

class IntlProvider extends Component {
    componentWillMount() {
        const findLanguage = []
            .concat(navigator.languages, navigator.language || navigator.userLanguage)
            .map(language => language.split('-')[0])
            .find(splitLanguage => locale[splitLanguage])
        this.props.dispatch({ type: 'onChangeLanguage', language: findLanguage })
    }
    render() {
        return (
            this.props.children
        );
    }
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(IntlProvider);


// WEBPACK FOOTER //
// ./src/IntlProvider.js